import { t } from "ember-intl";
import DataCenter from "glesys-controlpanel/components/data-center";
import Field from "glesys-controlpanel/components/entity/fields/field";

<template>
  <Field @label={{t "label.data-center"}} ...attributes>
    <DataCenter @dataCenter={{@dataCenter}} />
  </Field>
</template>
